import { EntityStatusTypes } from "@enums/entity-status-types";
import { PreviewEntityTypes } from "@enums/preview-entity-types";
import { MessagingTemplateTypes } from "@enums/messaging-template-types";
import {
    VerificationServiceDetailsValidationErrors
} from "@idw-types/common/validation/verification-service-details-validation-errors/verification-service-details-validation-errors";
import { FormattedRpServiceConfiguration } from "@idw-types/data/rp-service-configuration";
import { ActiveAcuantPropertyFlags } from "@idw-types/common/active-acuant-property-flags";
import {
    AXNUIContent,
    AXNUILayout,
    AXNUITheme,
    DCUIContent,
    DCUITheme
} from "@iddataweb/idw-common-ui/types";
import { FormattedMessagingTemplate } from "@idw-types/data/messaging-template";
import { DCUIThemingStep } from "@idw-types/common/dcui/dcui-theming-step";
import { getGeneralValidationErrors } from "./general/general-validation-util";
import { getServicesValidationErrors } from "./services-validation-util";
import { getThemingValidationErrors } from "../common/theming/theming-validation-util";
import { getAttributesValidationErrors } from "./attributes-validation-util";
import { getScoreValidationErrors } from "./scores-validation-util";
import { getPolicyDetailErrors } from "./policies-validation-util";
import { getDCUIThemingValidationErrors } from "../common/dcui-theming/dcui-theming-validation-util";
import { hasEmailPinServiceOffering } from "../../pin-code/pin-code-utils";
import { EmailTemplateFields } from "@idw-types/common/email-template-fields";
import { BaseRedirectUrl } from "@idw-types/redirect-url-information";

export const getVerificationServiceValidationErrors = (
    rpServiceConfiguration: FormattedRpServiceConfiguration,
    trustScoreServiceOfferingIDs: Array<string>,
    scoreServiceOfferingIDs: Array<string>,
    isUsingThemedUI: boolean,
    isUsingDCUIVersion2: boolean,
    hasDisplayableDocumentCaptureAttributes: boolean,
    showMessagingTab: boolean,
    showIncodeFlowTabs: boolean,
    showKbaFormTab: boolean,
    documentCaptureSteps: Array<DCUIThemingStep>,
    activeAcuantProperties: ActiveAcuantPropertyFlags,
    axnuiContent: AXNUIContent,
    axnuiLayout: AXNUILayout,
    axnuiTheme: AXNUITheme,
    dcuiContent: DCUIContent,
    dcuiTheme: DCUITheme,
    isDisplayResultsEnabled: boolean,
    redirectUrls: Array<BaseRedirectUrl>,
    availableMessagingTemplateTypes: Array<MessagingTemplateTypes>,
    selectedMessagingTemplates: Array<FormattedMessagingTemplate>,
    emailTemplateFields: EmailTemplateFields,
    showPinCodeSection: boolean
): VerificationServiceDetailsValidationErrors => {

    const activeServices = rpServiceConfiguration.serviceOfferings.filter(so =>
        so.addedToService &&
        so.status === EntityStatusTypes.ACTIVE &&
        so.serviceOfferingStatus === EntityStatusTypes.ACTIVE
    );
    const activeAttributes = rpServiceConfiguration.attributes.filter(attribute =>
        attribute.addedToService &&
        attribute.status === EntityStatusTypes.ACTIVE
    );

    const showEmailInputs = hasEmailPinServiceOffering(rpServiceConfiguration.serviceOfferings);

    const generalValidationErrors = getGeneralValidationErrors(rpServiceConfiguration, redirectUrls, showPinCodeSection);
    const servicesValidationErrors = getServicesValidationErrors(activeServices, activeAttributes);
    const themingValidationErrors = getThemingValidationErrors(
        PreviewEntityTypes.VERIFICATION_SERVICE,
        isUsingThemedUI,
        hasDisplayableDocumentCaptureAttributes,
        showMessagingTab,
        showIncodeFlowTabs,
        showKbaFormTab,
        showEmailInputs,
        emailTemplateFields,
        rpServiceConfiguration,
        axnuiContent,
        axnuiLayout,
        axnuiTheme,
        isDisplayResultsEnabled,
        redirectUrls,
        availableMessagingTemplateTypes,
        selectedMessagingTemplates
    );
    const dcuiThemingValidationErrors = getDCUIThemingValidationErrors(
        isUsingDCUIVersion2,
        hasDisplayableDocumentCaptureAttributes,
        documentCaptureSteps,
        activeAcuantProperties,
        dcuiContent,
        dcuiTheme
    );
    const attributesValidationErrors = getAttributesValidationErrors(activeServices, activeAttributes);
    const scoreValidationErrors = getScoreValidationErrors(rpServiceConfiguration, trustScoreServiceOfferingIDs, scoreServiceOfferingIDs);
    const policyDetailsErrors = getPolicyDetailErrors(axnuiContent,rpServiceConfiguration);

    const count = generalValidationErrors.count
        + servicesValidationErrors.count
        + themingValidationErrors.count
        + dcuiThemingValidationErrors.count
        + attributesValidationErrors.count
        + scoreValidationErrors.count
        + policyDetailsErrors.count;

    return {
        general: generalValidationErrors,
        services: servicesValidationErrors,
        theming: themingValidationErrors,
        dcuiTheming: dcuiThemingValidationErrors,
        attributes: attributesValidationErrors,
        scores: scoreValidationErrors,
        policies: policyDetailsErrors,
        count: count
    };
};